import React, {PropTypes} from 'react';
import Navigation from "../../components/common/Navigation";
import LinearProgress from "material-ui/LinearProgress";
import Banner from "../../components/common/Banner";
import {connect} from "react-redux";
import {hashHistory} from "react-router";
import toastr from "toastr";
import axios from "axios";


class QCap extends React.Component {

    constructor() {
      super();
    }

    render() {
      let options =[];
      if(this.props.employee.manager)
        options = [
          {
            text: "Performance Ratings",
            active: true,
            url: "#/1/qcap/home",
            url2: "#/1/qcap"
          },
          {
            text: "Team - Performance Ratings",
            active: false,
            url: "#/1/qcap/team"
          }
        ];
        else if (this.props.employee.function == 'MGMT')
      {
        options= [{
          text: "Team - Performance Ratings",
          active: true,
          url: "#/1/qcap/team",
          url2: "#/1/qcap"
        }
        ];
      }
      else
        options = [
          {
            text: "Performance Ratings",
            active: true,
            url: "#/1/qcap/home",
            url2: "#/1/qcap"
          }]

        return (
          <div>
            <Banner name="QCAP"/>
            <div className="container" style={{marginLeft: '10', marginRight: '10', width: '100%'}}>
              <div className="wrapper-1">
                <div className="row clearfix">
                  <div className="col-xs-12">
                    <div id="tab_content">
                      <Navigation options={options}/>
                      <div className="tab-content responsive" style={{padding: 0}}>
                        <div role="tabpanel" className="tab-panel">
                          <div className="row clearfix">

                            <div className="inner-col-wrap inner-table-wrap ">
                              {React.cloneElement(this.props.children, {
                               QCap: "ABSDSFDS",
                                employee: this.props.employee
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
    }
}


QCap.propTypes = {};

function mapStateToProps(state,ownProps)
{
    return {
      employee: state.emp[0]
    }
}

export default connect(mapStateToProps)(QCap);





/** WEBPACK FOOTER **
 ** ./src/feature/qcap/QCap.js
 **/